export default __webpack_public_path__ + "static/media/Like.9276958f.gif";